function toArray(value) {
  return Array.isArray(value) ? value : [value];
}

export default toArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/instantsearch.js/es/lib/utils/toArray.js
// module id = null
// module chunks = 